import { createFeatureSelector, createSelector } from '@ngrx/store';
import type { IRegistrationState } from './registration.reducer';

const getRegistrationState = createFeatureSelector<IRegistrationState>('registration');

export const getRegisterResidentActionState = createSelector(
  getRegistrationState,
  state => state.registerResidentActionState
);

export const getRegisterResidentResponse = createSelector(
  getRegistrationState,
  state => state.registerResidentResponse
);

export const getInvitationCodeResponse = createSelector(
  getRegistrationState,
  state => state.checkInvitationCodeResponse
);

export const getInvitationCodeState = createSelector(
  getRegistrationState,
  state => state.checkInvitationCodeState
);

export const getCheckEmailExistsResponse = createSelector(
  getRegistrationState,
  state => state.checkEmailExistsResponse
);

export const getCheckEmailExistsState = createSelector(
  getRegistrationState,
  state => state.checkEmailExistsState
);

export const getRequestInvitationCodeResponse = createSelector(
  getRegistrationState,
  state => state.requestInvitationCodeResponse
);

export const getRegistrationForm = createSelector(
  getRegistrationState,
  state => state.registrationForm
);
